import styled, { css } from 'styled-components';

const StyleMenu = styled.div`
  border-right: solid 1px ${({ theme }) => theme.palette.border.main};
  width: 128px;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.sizes.smalldesktop}px) {
    width: 110px;
  }
`;

const StyleMenuItem = styled.div`
  height: 118px;
  border-bottom: solid 1px ${({ theme }) => theme.palette.border.main};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  flex-direction: column;
  transition: all ease 0.25s;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    width: 2px;
    height: 0px;
    transition: all ease 0.25s;
    background: ${({ theme }) => theme.palette.primary.main};
  }
  & > span {
    color: ${({ theme }) => theme.palette.primary.main};
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
    display: block;
    text-align: center;
    text-decoration: none;
    transition: all ease 0.25s;
  }
  & > img {
    transition: all ease 0.25s;
    margin-bottom: 15px;
  }
  &:hover {
    opacity: 1;
  }
  &:hover > img {
    transform: translateY(-5px);
  }
  &:hover > span {
    transform: translateY(5px);
  }
  &:hover:before {
    height: 100%;
  }
`;

const StyleLogo = styled(StyleMenuItem)`
  background: linear-gradient(
    to right,
    ${({ theme }) => theme.palette.background.linearmenulight},
    ${({ theme }) => theme.palette.background.linearmenudark}
  );
  border-bottom: none;
  & > img {
    margin-bottom: 0;
  }
`;

const StyleLogout = styled(StyleMenuItem)`
  margin-top: auto;
  & > span {
    color: ${({ theme }) => theme.palette.secondary.main};
  }
  &:before {
    background: ${({ theme }) => theme.palette.secondary.main};
  }
`;

export { StyleMenu, StyleMenuItem, StyleLogo, StyleLogout };
